import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2, User, Briefcase } from "lucide-react";
import api from "@/lib/api";
import { PageHero, Loading, Empty } from "@/components/common";

const TYPES = [
  { k: "", label: "Todos" },
  { k: "funcionario", label: "Funcionarios" },
  { k: "agencia", label: "Agencias" },
  { k: "contratista", label: "Contratistas" },
];
const ICON = { funcionario: User, agencia: Building2, contratista: Briefcase };

export default function Entities() {
  const [items, setItems] = useState(null);
  const [type, setType] = useState("");

  useEffect(() => {
    setItems(null);
    api.get("/entities", { params: type ? { entity_type: type } : {} }).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [type]);

  return (
    <div data-testid="entities-page">
      <PageHero label="Perfiles" title="Funcionarios, agencias y contratistas"
        subtitle="Perfiles navegables con investigaciones y promesas relacionadas para dar seguimiento al poder público." />
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="flex flex-wrap gap-2 mb-8">
          {TYPES.map((t) => (
            <button key={t.k} onClick={() => setType(t.k)} data-testid={`entity-filter-${t.k || "all"}`}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${type === t.k ? "bg-slate-900 text-white" : "bg-white border border-slate-200 text-slate-600 hover:bg-slate-100"}`}>{t.label}</button>
          ))}
        </div>
        {items === null ? <Loading /> : items.length === 0 ? <Empty label="No hay perfiles disponibles." /> : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {items.map((e) => {
              const Icon = ICON[e.entity_type] || Building2;
              return (
                <Link key={e.id} to={`/perfiles/${e.id}`} data-testid={`entity-card-${e.id}`}
                  className="block bg-white rounded-lg border border-slate-200 p-5 hover:shadow-md hover:-translate-y-1 transition-all duration-200">
                  <div className="w-11 h-11 rounded-lg bg-slate-900 flex items-center justify-center mb-3">
                    <Icon className="w-5 h-5 text-cyan-400" />
                  </div>
                  <span className="text-xs font-semibold text-cyan-600 uppercase tracking-wide">{e.role_title || e.entity_type}</span>
                  <h3 className="font-heading font-bold text-lg text-slate-900 mt-1 mb-1">{e.name}</h3>
                  {e.description && <p className="text-slate-600 text-sm line-clamp-2">{e.description}</p>}
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
